import { object, string } from 'yup';

export default object({
  advisorName: string()
    .required()
    .label('Naam'),
});
